<template>
    <div>
        <app-table
			class="mt-3 no-main-list"
			:columns="columns"
			:filter-columns="false"
			:main-list="true"
			:rows="rows"
			:check-all="checkAll"
			selectable
			flagRoute
			btn-actions
			:items-quantity="totalItemsVisible"
			:items-total-quantity="totalItems"
			:current-page="currentPage"
			:last-page="lastPage"
			title="Seleccionar Empleados"
			@row-is-selected="rowIsSelected"
			@on-selected-all="selectedAll"
			@on-page="$emit('on-page', $event)"
			@on-search-event="$emit('on-search-event', $event)"
			@changeSort="$emit('changeSort', $event)"
			@changeColor="changeColor">
			<template slot="action">
				<p class="num-employee">{{ numEmployeesSelect }} / {{ numEmployees }}</p>
			</template>
				<template slot="rows" slot-scope="props">
					<td v-show="showRow(columns, 1)">{{ props.row.name }} {{ props.row.lastName }}</td>
					<td v-show="showRow(columns, 2)">{{ props.row.phoneNumber }}</td>
					<td v-show="showRow(columns, 3)">{{ props.row.email }}</td>
				</template>
		</app-table>
    </div>
</template>

<script>

function created() {
	if (this.$route.name === 'edit-choose-employees' || 'process-choose-employees') {
		this.flagRoute = true;
	} else {
		this.flagRoute = false;
	}
}

function numEmployees() {
	return this.rows.length;
}

function numEmployeesSelect() {
	const numSelct = this.rows.filter(isSelc => isSelc.isSelected === true);
	return numSelct.length;
}

function rowIsSelected(value) {
	this.$emit('row-is-selected', value);
}

function selectedAll(value) {
	this.$emit('selected-all', value);
}

function changeColor(fieldName) {
	this.columns.forEach((c, index) => {
		if (c.fieldName !== fieldName && c.color) {
			this.$set(this.columns, index, { ...c, color: 'gray' });
		}
	});
}


export default {
	name: 'process-list-employee',
	data() {
		return {
			flagRoute: false,
			columns: [
				{
					id: 1,
					name: 'Seleccionar Todos',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'last_name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'Teléfono',
					value: 'phoneNumber',
					visible: true,
					checked: true,
				},
				{
					id: 3,
					name: 'Correo',
					value: 'email',
					visible: true,
					checked: true,
				},
			],
		};
	},
	created,
	components: {
	},
	methods: {
		rowIsSelected,
		selectedAll,
		changeColor,
	},
	computed: {
		numEmployees,
		numEmployeesSelect,
	},
	props: {
		rows: {
			default: () => [],
			type: Array,
		},
		checkAll: {
			type: Boolean,
			default: false,
		},
		currentPage: [Number, String],
		lastPage: [Number, String],
		totalItems: [Number, String],
		totalItemsVisible: [Number, String],
		flagNum: [Number],
	},
	watch: {
		flagNum: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.columns.forEach((c, index) => {
						this.$set(this.columns, index, { ...c, color: 'gray' });
					});
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.num-employee {
	color: map-get($colors , orange-dark);
	font-size: 26px;
	font-weight: bold;
	padding-top: 10px;
	height: auto;

}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/components/process/process-list-employee.vue